import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Navigation from '.././Navigation';
import classnames from 'classnames';
import './style.sass';

export default class Header extends Component {
  static propTypes = {
    links: PropTypes.object
  }

  static defaultProps = {
    links: []
  }

  // state = {}

  render() {
    const { className, links } = this.props;

    return (
      <div className={classnames('Header', className)}>
        <a className="Header-headline" href="/">
          Kah Hong Tay
        </a>
        <Navigation links={links} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Header/index.js